module.exports = __webpack_public_path__ + "img/State=16.0af3a1d4.svg";